export default __webpack_public_path__ + "static/countryBackground-098ad6f01f6519276fed1246f255a042.webp";